import React from "react";
import { motion } from "framer-motion";
import { X, Sparkles, MoveRight } from "lucide-react";

export default function PopupNovita({ isOpen, onClose, product, onViewDetail }) {
    if (!isOpen || !product) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            {/* Overlay di Sfondo con sfocatura cinema */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onClose}
                className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            />

            {/* Contenitore Popup */}
            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.9, y: 20 }}
                transition={{ type: "spring", duration: 0.4, bounce: 0.2 }}
                className="relative w-full max-w-sm bg-[#121824] border border-accent/40 rounded-3xl p-6 shadow-2xl shadow-black/80 z-10 overflow-hidden text-center text-secondary"
            >
                {/* Pulsante di Chiusura Rapida */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-1.5 rounded-full bg-[#090D16] border border-accent/20 text-muted hover:text-secondary transition-colors"
                    aria-label="Chiudi"
                >
                    <X className="w-4 h-4" />
                </button>

                {/* Badge Animato Superiore */}
                <div className="inline-flex items-center gap-1.5 bg-primary/10 border border-primary/30 px-3 py-1 rounded-full text-primary text-[10px] font-black uppercase tracking-widest mb-4 animate-pulse">
                    <Sparkles className="w-3.5 h-3.5 fill-primary" />
                    Novità della Settimana
                </div>

                {/* Immagine Circolare Premium */}
                {product.image && (
                    <div className="relative w-28 h-28 rounded-full border-4 border-primary/30 bg-[#090D16] mx-auto overflow-hidden shadow-lg shadow-black/40 mb-4">
                        <img
                            src={product.image}
                            alt={product.title}
                            crossOrigin="anonymous"
                            className="w-full h-full object-cover"
                        />
                    </div>
                )}

                {/* Titolo e Descrizione/Ingredienti */}
                <h3 className="text-xl font-black tracking-tight leading-tight mb-2 text-secondary px-2">
                    {product.title}
                </h3>
                
                {product.ingredients && (
                    <p className="text-xs text-muted/80 leading-relaxed max-w-[240px] mx-auto mb-6 line-clamp-2">
                        {product.ingredients}
                    </p>
                )}

                {/* Pulsanti di Azione */}
                <div className="flex flex-col gap-2.5">
                    <button
                        onClick={() => {
                            onClose(); 
                            onViewDetail(product);
                        }}
                        className="flex items-center justify-center gap-2 w-full bg-primary text-black font-bold text-sm py-3 rounded-xl shadow-lg shadow-primary/10 active:scale-[0.98] transition-all"
                    >
                        Scopri il Piatto
                        <MoveRight className="w-4 h-4 stroke-[2.5]" />
                    </button>
                    
                    <button
                        onClick={onClose}
                        className="w-full text-xs font-semibold text-muted hover:text-secondary py-1.5 transition-colors"
                    >
                        Più tardi
                    </button>
                </div>
            </motion.div>
        </div>
    );
}